import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './shared/material.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpInterceptorInterceptor } from "./core/interceptor/http-interceptor.interceptor";
import { AuthService } from "./shared/services/auth.service";
import { HomeComponent } from './home/home.component';
import { SharedModule } from "./shared/shared.module";
import { SidenavListComponent } from './navigation/sidenav-list/sidenav-list.component';
import { MsalModule } from "@azure/msal-angular";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "../environments/environment";

@NgModule({
    declarations: [
      AppComponent,
      HomeComponent,
      SidenavListComponent
    ],
    bootstrap: [ AppComponent ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialModule,
        SharedModule,
        MsalModule.forRoot(new PublicClientApplication({
            auth: {
                clientId: environment.graphToolkit.clientId,
                authority: environment.graphToolkit.authority,
                redirectUri: window.location.origin,
            },
            cache: {
                cacheLocation: 'localStorage',
                storeAuthStateInCookie: false, 
            }
        }), {
            interactionType: InteractionType.Redirect
        }, null)
    ],
    providers: [
      AuthService,
      provideHttpClient(withInterceptorsFromDi()),
      { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorInterceptor, multi: true }
    ]
})
export class AppModule { }
